module.exports = __webpack_public_path__ + "img/1481118003.9eef9144.jpg";